import React from 'react'
import { useGetRoomSessionQuery } from '../../store/media/media'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { Button } from '../Button/Button'
import { Col, Row, Spinner } from 'react-bootstrap'
import { formatDateDDMMYYYY, formatDateHM } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { parseMetadata } from '../../common/util'
import { SourceIcon } from '../../apps/professional-app/fa/PastMeetings/SourceIcon'
import { useEffectivePlatform } from '../../common/useEffectivePlatform'
import './MeetingContainer.scss'

export interface MeetingContainerProps {
  roomId: string
  sessionId: string
}
export const MeetingContainer: React.FC<MeetingContainerProps> = ({ roomId, sessionId }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: roomSession, isFetching: isRoomSessionFetching } = useGetRoomSessionQuery({ accountId, roomId, sessionId })
  const baseUrl = import.meta.env.REACT_APP_INTEGRATION_REDIRECT_URL
  const roomSessionMetadata = roomSession?.data ? parseMetadata(roomSession.data.metadata) : {}
  const { source, external: { platform = null, title = null, userAgent = null } = {} } = roomSessionMetadata

  const effectivePlatform = useEffectivePlatform(source, platform, userAgent)

  return (
    <div>
      {!isRoomSessionFetching && roomSession?.data ? (
        <div className='d-flex flex-column gap-2'>
          <div className='label-small zocks-text-primary'>The answer is based on this meeting:</div>
          <Col className='meeting-container d-flex flex-column gap-1'>
            <Row className='lead-medium'>
              <Col>{formatDateDDMMYYYY(roomSession.data.startedAt)}</Col>
            </Row>
            <Row className='d-flex justify-content-between align-items-center'>
              <Col xs='auto'>
                <SourceIcon source={effectivePlatform ? `${source}-${effectivePlatform}` : source} />
              </Col>
              <Col>
                <div className='lead-small'>
                  {formatDateHM(roomSession.data.startedAt)}-{roomSession.data.finishedAt ? formatDateHM(roomSession.data.finishedAt) : null}
                </div>
                <div className='paragraph-large medium bold'>{title || <div className='paragraph-extra-small'>Untitled meeting.</div>}</div>
              </Col>
              <Col xs='auto'>
                <a href={`${baseUrl}/workspace/past-meetings/room/${roomId}/session/${sessionId}`} target='_blank' rel='noopener noreferrer'>
                  <Button className='button-medium px-3 py-1' variant='primary'>
                    View
                  </Button>
                </a>
              </Col>
            </Row>
          </Col>
        </div>
      ) : isRoomSessionFetching ? (
        <Spinner />
      ) : null}
    </div>
  )
}
